<template>
    <div class="template-box">
        <div class="card-horizontal-title" :class="product.promotional_price? 'description-promotion' : 'description'">
            <h5 class="main-title">Campanha <br> {{product.title}}</h5>

            <p v-if="product.description" class="product-description">
                {{ product.description }}
            </p>
        </div>

        <div v-if="product.campaign_type != 'segment'" class="price-rating">
            <template v-if="product.promotional_price">
                <div class="arrow-container">
                    <p class="arrow-discount">
                        <span>-{{ product.discount_percentage }}%</span>
                    </p>
                </div>

                <p class="promotional text-muted">
                    <small>R$ {{product.price}}</small>
                </p>
                <p>R$ {{product.promotional_price}}</p>
            </template>
            <template v-else>
                <p class="product-price">R$ {{product.price}}</p>
            </template>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'template-content',

    props: {
      product: Object,
    },
  };
</script>

<style scoped>
    .main-title {
        margin-bottom: 0;
        font-weight: 500;
    }

    .promotional {
        text-decoration: line-through;
        text-decoration-color: #ED1763;
        margin: 0;
        color: #777;
    }

    .template-box {
        height: 100%;
    }

    .description-promotion {
        height: 65%;
        min-height: 175px;
    }

    .description {
        height: 73%;
        padding: 0;
    }

    .product-price {
        color: #000000;
        font-size: 16px;
        margin-bottom: 0;
        font-weight: 400;
        font-family: Montserrat;
    }

    .product-description {
        font-size: 12px;
        font-weight: 300;
        padding-top: 3px;
        white-space: pre-line;
        top: -20px;
        position: relative;
    }

    .promotional-discount {
        background-color: #f84a5f;
        font-size: 14px;
        font-weight: bold;
        height: 22px;
        padding: 4px;
        color: #FFD400;
        border-radius: 5px;
    }

    .arrow-container {
        bottom: 45px;
        left: 16px;
        position: absolute;
    }

    .arrow-discount {
        height: 24px;
        background: #ED1763;
        width: 50px;
        font-size: 14px;
        border-radius: 5px;
        font-weight: bold;
        color: #FFD400;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/store/components/TemplateContent.vue